import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RelayError } from '../../domain/error';
import { SpinnerService } from '../../spinner.service';
import { JuiButton } from '@jump-tech-frontend/core-components-angular';


@Component({
    selector: 'error-modal-component',
    template: ` @if (error) {
  <div [attr.data-qa]="'error'" class="modal-wrapper">
    <div class="modal-header">
      <div>{{ error.title }}</div>
    </div>
    <div class="modal-body">
      <div [innerHTML]="error.message"></div>
    </div>
    <div class="modal-footer text-center">
      @if (!error.action) {
        <jui-button
          size="xl"
          title="{{ error.okLabel }}"
          color="primary"
          (click)="close($event)"
          [attr.data-qa]="'errorOkButton'"
          >
          {{ error.okLabel }}
        </jui-button>
      }
      @if (error.action) {
        <jui-button
          size="xl"
          title="{{ error.cancelLabel }}"
          display="ghost"
          color="secondary"
          (click)="close($event)"
          [attr.data-qa]="'errorCancelButton'"
          >
          {{ error.cancelLabel }}
        </jui-button>
      }
      @if (error.action) {
        <jui-button
          size="xl"
          title="{{ error.actionLabel }}"
          color="primary"
          (click)="action($event)"
          [attr.data-qa]="'errorActionButton'"
          >
          {{ error.actionLabel }}
        </jui-button>
      }
    </div>
  </div>
}`,
    styles: [
        `
      .modal-body {
        background-color: var(--jds-theme-color-primary-contrast-color, white);
        color: var(--survey-text-color, var(--jds-theme-color-text));
      }

      .modal-header {
        background-color: var(--jds-theme-color-primary, var(--jds-theme-color-state-danger));
        color: var(--jds-theme-color-primary-contrast-color, white);
      }
    `
    ],
    imports: [JuiButton]
})
export class ErrorModalComponent {
  @Input() error!: RelayError;

  constructor(public activeModal: NgbActiveModal, private spinnerService: SpinnerService) {
    this.spinnerService.hideSpinner();
  }

  action($event: Event) {
    $event.preventDefault();
    this.activeModal.close(true);
  }

  close($event: Event) {
    $event.preventDefault();
    this.activeModal.close(false);
  }
}
